import React from 'react';
import PropTypes from 'prop-types';
import API from 'services/API';
import fetch from 'whatwg-fetch'; // eslint-disable-line no-unused-vars
import features from 'lib/common/features';
import arrayWrap from 'lib/common/arrayWrap';
import get from 'lodash/get';
import { ACTIONS } from 'mediator';
import mediator from 'mediator';

const STATUSES = {
  NOT_ASKED: 'NOT_ASKED',
  VALIDATING: 'VALIDATING',
  PENDING: 'PENDING',
  REMOVING: 'REMOVING',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE'
};

function checkRawStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    let err = new Error(response.statusText);
    err.response = response;
    throw err;
  }
}

const PromoCode = React.createClass({
  propTypes: {
    loginInfo: PropTypes.object,
    onPromoCodeReady: PropTypes.func.isRequired,
    isAvailable: PropTypes.bool // eslint-disable-line react/no-unused-prop-types
  },
  getInitialState: function() {
    return {
      value: '',
      status: STATUSES.NOT_ASKED,
      activePromoCode: false,
      endpoints: features.getOption('promoCode', 'endpoints'),
      activePromoCodeCopy: [],
      selectedLevel: null
    };
  },
  componentDidMount: function() {
    if (this.props.loginInfo) {
      this.checkInitialSourceCode(this.props.loginInfo);
    }

    mediator.subscribe(ACTIONS.LEVEL_SELECTED, level => {
      this.setState({
        selectedLevel: level
      });
    });
  },
  componentWillReceiveProps(newProps) {
    if (newProps.loginInfo && newProps.loginInfo !== this.props.loginInfo) {
      this.checkInitialSourceCode(newProps.loginInfo);
    }
  },

  determineCopyForPromoCode(promoCode) {
    let copy = [];
    for (let n in promoCode) {
      if (n.match(/text/)) {
        copy.push(promoCode[n]);
      }
    }
    return copy;
  },

  checkInitialSourceCode: function(loginInfo) {
    var initialSourceCode = get(loginInfo, 'promotion_code');
    var currentMos = get(loginInfo, 'MOS');

    this.setState({
      status: STATUSES.VALIDATING
    });

    API.GetPromoCodeEx(initialSourceCode).then(
      activePromoCodes => {
        var matchingPromoCodes = arrayWrap(activePromoCodes).filter(function(
          item
        ) {
          return (
            item.promo_code &&
            parseInt(item.mos, 10) === parseInt(currentMos, 10)
          );
        });

        if (matchingPromoCodes.length) {
          let matchingPromoCode = matchingPromoCodes[0];
          this.props.onPromoCodeReady(matchingPromoCode);

          // We could have up to 6 lines of text in here
          let promoCopy = this.determineCopyForPromoCode(matchingPromoCode);

          this.setState({
            status: STATUSES.SUCCESS,
            // Take the first matching promocode
            activePromoCode: matchingPromoCode.promo_code,
            // Add the copy to the state
            activePromoCodeCopy: promoCopy
          });
        } else {
          this.setState({
            status: STATUSES.NOT_ASKED
          });
        }
      },
      () => {
        this.setState({
          status: STATUSES.NOT_ASKED
        });
      }
    );
  },
  addPromoCode: function(promoCode) {
    this.setState({
      status: STATUSES.PENDING
    });

    var data = new FormData();
    data.append('promocode', promoCode);

    return window
      .fetch(this.state.endpoints.add, {
        method: 'POST',
        credentials: 'same-origin',
        body: data
      })
      .then(checkRawStatus)
      .then(response => response.text())
      .then(
        response => {
          if (response === 'success') {
            this.setState({
              status: STATUSES.SUCCESS
            });

            let redirectUrl = window.location.href;

            if (window.location.href.indexOf('?') != -1) {
              redirectUrl = redirectUrl.substring(0, redirectUrl.indexOf('?'));
            }

            if (
              this.state.selectedLevel &&
              this.props.selectedLevel != ACTIONS.LEVEL_SELECTOR_CONTAINER
            ) {
              redirectUrl =
                redirectUrl +
                '?skip_level_selector=1&level=' +
                this.state.selectedLevel;
            }

            window.location.href = redirectUrl;
          } else {
            this.setState({
              status: STATUSES.FAILURE
            });
          }
        },
        () => {
          this.setState({
            status: STATUSES.FAILURE
          });
        }
      );
  },
  removePromoCode: function() {
    this.setState({
      status: STATUSES.REMOVING
    });

    return window
      .fetch(this.state.endpoints.remove, {
        method: 'POST',
        credentials: 'same-origin'
      })
      .then(checkRawStatus)
      .then(response => response.text())
      .then(
        response => {
          if (response === 'success') {
            this.setState({
              status: STATUSES.NOT_ASKED
            });

            window.location.reload();
          } else {
            this.setState({
              status: STATUSES.FAILURE
            });
          }
        },
        () => {
          this.setState({
            status: STATUSES.FAILURE
          });
        }
      );
  },
  handleChange(event) {
    this.setState({
      value: event.target.value
    });
  },
  handleSubmit: function(event) {
    event.preventDefault();
    var inputValue = this.state.value;

    if (this.state.activePromoCode) {
      this.removePromoCode();
    } else if (inputValue) {
      this.addPromoCode(inputValue);
    }
  },
  getButtonLabel: function() {
    var labels = {
      NOT_ASKED: 'Apply',
      PENDING: 'Applying',
      REMOVING: 'Removing',
      SUCCESS: 'Remove',
      FAILURE: 'Apply'
    };

    return labels[this.state.status] || labels[STATUSES.NOT_ASKED];
  },
  formatPromoCopy() {
    return this.state.activePromoCodeCopy.join('<br />');
  },
  render: function() {
    const placeholderValue =
      features.getOption('promoCode', 'label') || 'Promotional Code';

    return this.state.status === STATUSES.VALIDATING ? (
      <p className="promo-code-loading">
        Checking for existing promotional code…
      </p>
    ) : (
      <form className="promo-code-form" action="" onSubmit={this.handleSubmit}>
        <div className="promo-code-form__field">
          <div className="input-addon">
            <input
              className="input-addon__input"
              type="text"
              onChange={this.handleChange}
              placeholder={placeholderValue}
              value={this.state.activePromoCode || this.state.value}
              readOnly={this.state.activePromoCode}
            />
            <input
              className="input-addon__action syos-button"
              type="submit"
              disabled={this.state.status === STATUSES.PENDING}
              value={this.getButtonLabel()}
            />
          </div>

          {features.getOption('promoCode', 'displayCopy') &&
          this.state.activePromoCodeCopy.length ? (
            <p dangerouslySetInnerHTML={{ __html: this.formatPromoCopy() }} />
          ) : null}
        </div>
        {this.state.status === STATUSES.FAILURE && (
          <p className="promo-code-form__message">
            The promotional code you entered is not valid
          </p>
        )}
      </form>
    );
  }
});

export default PromoCode;



// WEBPACK FOOTER //
// ./src/javascripts/app/components/PromoCode.js